<template>
    <div class="result-contain flex-fill">
        <div v-if="messages !== null && messages !== undefined && messages.length > 0">
            <div v-for="message in messages" :key="message.ChatInc">
                <MessageFilterItem :message="message" />
            </div>
        </div>
        <div v-else-if="!loading && messages !== null && messages !== undefined && messages.length === 0 && loaded">
            <p>{{ $t('message.item.nothing_found') }}</p>
        </div>
    </div>
</template>

<script>
import MessageFilterItem from 'modules/messages/MessageFilterItem.vue'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            loaded: false
        }
    },
    name: 'MessageFilterResult',
    components: { MessageFilterItem },
    computed: {
        ...mapState({
            hotels: state => state.messages.hotels,
            messages: state => state.messages.messages,
            loading: state => state.messages.loading,
            isEmptyMessages: state => state.messages.isEmptyMessages,
            messagesInfo: state => state.messages.messagesInfo
        }),
    },
    watch: {
        messages() {
            this.loaded = true
        }
    }
}
</script>

<style scoped>
.result-contain{
    height: calc(100vh - 500px);
    overflow-y: auto;
}
@media (max-width: 1200px) {
    .result-contain{
        height: calc(100vh - 600px);
    }
}
@media (max-width: 575px) {
    .result-contain{
        height: calc(100vh - 730px);
    }
}
</style>
